export default "__VITE_ASSET__BzJFD9Sy__"